<template>

    <div v-if="userStore.currentUserConfig">

        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-md-6">
                        <h2>User Registration</h2>
                    </div>
                    <div v-if="documentReady && !isSigned">
                        <div class="col-md-offset-8 margin-right">
                            <button type="button" class="btn btn-primary custom-button" @click.prevent="checkIfSigned">Continue</button>
                            <a href=".\" class="btn btn-default custom-button pull-right">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="panel-body">

                <div v-if="error" class="alert alert-danger" role="alert">
                    {{error}}
                </div>

                <div v-if="user.status === 'Details'">

                    <div v-if="userStore.config">
                        <p v-html="userStore.config.header" class="alert alert-info"></p>
                    </div>

                    <div v-if="userStore.currentUserConfig && userStore.currentUserConfig.attachments">

                        <div v-for="(doc, docIndex) in userStore.currentUserConfig.attachments" :key="docIndex">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <div>
                                        <label class="label label-default" style="font-size:small;">
                                            {{doc}}
                                        </label>
                                    </div>

                                    <div class="text-muted">
                                        {{fileText}}
                                    </div>
                                </div>

                                <div v-if="canSelectFile(docIndex)" class="col-md-2">
                                    <button type="button" @click="clickFileInput(docIndex)" class="btn btn-primary">
                                        Browse
                                    </button>

                                    <input type="file" :ref="setFileInputRef" @change="addFile(docIndex, doc)" style="display:none" />
                                </div>
                            </div>

                            <div class="row">
                                <div v-for="file in files" :key="file.index">
                                    <div v-if="file.index === docIndex">
                                        <div v-if="file.error" class="col-md-4">
                                            <p>
                                                <span class="label label-danger" style="font-size:small;">
                                                    {{file.error}}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom:1em;">
                                <div v-if="user.userType === regTypes.REGUSER">
                                    <div class="col-md-3">
                                        <img :ref="setImageRef" width="150" height="100" alt="Document preview" />
                                    </div>
                                </div>

                                <div v-for="file in files" :key="file.index">
                                    <div v-if="file.index === docIndex">
                                        <div v-if="user.userType !== regTypes.REGUSER" class="col-md-4 text-muted">
                                            {{file.name}}
                                        </div>

                                        <div v-if="!file.error" class="col-md-1">
                                            <button class="btn btn-secondary" @click.prevent="removeFile(file, docIndex)">
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <UserInfo :confid="confID"></UserInfo>
                </div>

                <div v-if="user.status === 'Documents'">
                    <div v-if="user.userType === regTypes.REGUSER">
                        <div v-if="!isSigned">
                            <div v-if="!documentReady" class="row">
                                <div class="col-md-1 text-right">
                                    <span class="glyphicon glyphicon-check icon-size"></span>
                                </div>
                                <div class="col-md-11">
                                    <p v-html="userStore.config.signdocuments.before"></p>
                                    <button type="button" class="btn btn-primary pull-right" @click.prevent="signDocs">Accept and Continue</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="alert alert-info" role="alert">
                                    Choose your signature and sign the document. After signing, click the Complete button to finish the signing process.
                                </div>
                                <div>
                                    <iframe :src="user.signatureLink" class="myFrame" title="Signature Document"></iframe>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <p v-html="userStore.config.signdocuments.after"></p>

                            <div class="row col-md-offset-10 margin-right">
                                <a href=".\" class="btn btn-default custom-button pull-right">OK</a>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <p v-html="userStore.config.signdocuments.after"></p>

                        <div class="row col-md-offset-10 margin-right">
                            <a href=".\" class="btn btn-default custom-button pull-right">OK</a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="user.status === 'Details'">
                <div class="panel-footer">
                    <div v-if="user.userType === regTypes.REGUSER && confID">
                        <div class="row">
                            <div class="col-md-offset-6">
                                <button v-if="editing" type="button" class="btn btn-primary custom-button-margin" @click="userStore.updateRegistration(confID)">Save</button>
                                <button v-if="!editing" type="button" class="btn btn-primary custom-button-margin" @click="userStore.setEditMode(true)">Edit</button>
                                <button type="button" v-bind:class="{'btn btn-primary custom-button-margin': validFiles, 'btn btn-default custom-button-margin': !validFiles}" @click.prevent="addFiles" :disabled="!validFiles">Continue</button>
                                <a href=".\" class="btn btn-default custom-button-margin">Cancel</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row margin-right">
                            <div class="col-md-offset-8">
                                <button type="button" v-bind:class="{'btn btn-primary custom-button': validFiles, 'btn btn-default custom-button': !validFiles}" @click.prevent="addFiles" :disabled="!validFiles">Continue</button>
                                <a href=".\" class="btn btn-default custom-button pull-right">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

    .myFrame {
        width: 100%;
        height: 75vh;
    }

    h2 {
        display: inline-block;
        margin: 0;
    }

    .custom-button {
        width: 48%;
    }

    .custom-button-margin {
        width: 30%;
        margin-right: 0.75em;
    }

    .margin-right {
        margin-right: 0.5em;
    }

    .col-align-top {
        float: none;
        display: inline-block;
        vertical-align: top;
    }

    .col-align-center {
        float: none;
        display: inline-block;
        vertical-align: middle;
    }

    [data-toggle="collapse"].collapsed .opened {
        display: none;
    }

    [data-toggle="collapse"]:not(.collapsed) .closed {
        display: none;
    }

    .icon-size {
        font-size: xx-large;
    }

    .alert-info {
        color: black;
    }

    .alert-danger {
        color: black;
    }
</style>

<script setup>

    import { storeToRefs } from 'pinia'
    import { useUserStore, userRegTypes } from '@/stores/user.store'
    import { defineProps, reactive, ref, computed } from "vue";
    import UserInfo from '@/userregistration/userinformation.vue'
    import { useLoading } from 'vue-loading-overlay';
    import lockImage from '@/assets/icons8-lock-50.png'

    const userStore = useUserStore()
    const regTypes = userRegTypes

    const { user, error, config, userConfig, editing, currentUserConfig, documentReady } = storeToRefs(userStore)

    const props = defineProps({
        id: {
            type: String,
            required: true,
        }
    });

    const $loading = useLoading();

    let userInfoOpen = ref(false);
    let confID = ref();
    let isSigned = ref(false);

    let files = reactive([]);
    let fileInputRefs = reactive([]);
    let imageRefs = reactive([]);

    const setFileInputRef = el => {
        if (el) {
            fileInputRefs.push(el);
        }
    };

    const setImageRef = el => {
        if (el) {
            imageRefs.push(el);
        }
    };

    function clickFileInput(index) {

        fileInputRefs[index].click();
    }

    function addFile(index, doc) {

        let existingFile;

        for (var i = 0, iLen = files.length; i < iLen; i++) {
            if (files[i].index == index) {
                existingFile = files[i];
                break;
            }
        }

        if (existingFile) {
            removeFile(existingFile, index);
        }

        let fileAdded = fileInputRefs[index].files[0];

        let invalidMsg = invalidFileMessage(fileAdded);

        let f = {
            index: index,
            file: fileAdded,
            url: URL.createObjectURL(fileAdded),
            name: fileAdded.name,
            error: invalidMsg,
            label: doc
        }

        files.push(f);

        if (fileAdded.type !== 'application/pdf' && userStore.user.userType === regTypes.REGUSER) {
            if (!f.error) {
                imageRefs[index].src = f.url;
            }
        }

        fileInputRefs[index].value = ""; //needed to allow to upload same file again
    }

    function removeFile(fileToDelete, index) {

        let deleteIndex = files.indexOf(fileToDelete);

        if (deleteIndex > -1) files.splice(deleteIndex, 1);

        if (imageRefs[index] && imageRefs[index].src) {
            imageRefs[index].src = "";
        }
    }

    function invalidFileMessage(file) {

        let message = '';

        let allowedTypes = currentUserConfig.value.supportedAttachmentType;

        let maxSize = currentUserConfig.value.maxUploadSize;

        if (file.size > maxSize)
            message = 'File size exceeded the maximum limit.' + '\r\n';

        if (!allowedTypes.includes(file.type))
            message = message + 'Invalid file type.';

        console.log(message);
        return message;
    }

    function canSelectFile(docIndex) {
        //check if files collection already has a valid file for this document.
        for (var i = 0; i < files.length; i++) {
            if (files[i].index === docIndex && files[i].error === '') {
                return false;
            }
        }

        return true;
    }

    async function addFiles() {

        let formData = new FormData();

        for (var i = 0; i < files.length; i++) {
            let file = files[i].file;

            formData.append('files[' + i + ']', file);
        }

        const loader = $loading.show();

        await userStore.uploadDocument(formData, props.id);

        loader.hide()
    }

    //computed

    const validFiles = computed({

        get() {

            let attachments = currentUserConfig.value.attachments;

            if (!attachments || attachments.length === 0) return true;

            if (files.length === 0 || attachments.length != files.length) return false;

            files.forEach(f => {
                if (invalidFileMessage(f.file)) {
                    return false;
                }
            })

            return true;
        }
    })

    const fileText = computed({

        get() {

            let allowedTypes = currentUserConfig.value.supportedAttachmentType;
            let maxUploadSize = currentUserConfig.value.maxUploadSize;

            let fileTypes;
            let maxFileSize;

            if (allowedTypes.includes('image/jpeg')) {
                fileTypes = 'jpeg, jpg';
            }
            else if (allowedTypes.includes('application/pdf')) {
                fileTypes = 'pdf';
            }

            if (maxUploadSize) {
                maxFileSize = `${maxUploadSize / 1000}Kb`;
            }

            return `${fileTypes} files only. Maximum file size: ${maxFileSize}`;
        }
    })

    const title = computed({

        get() {
            if (user.value.status === 'Documents') {
                return 'User Registration > Sign Documents';
            }

            return 'User Registration';
        }
    })

    async function signDocs() {

        const loader = $loading.show();

        await userStore.isDocumentReady(confID);

        loader.hide();
    }

    async function checkIfSigned() {

        const loader = $loading.show();

        isSigned.value = await userStore.isDocumentSigned(confID);

        loader.hide()
    }

    async function load() {

        confID = props.id;

        await userStore.loadConfig();

        await userStore.loadCurrentUser(props.id);
    };

    (async () => {
        await load();
    })();


</script>
